import { useLang } from '../context/LanguageContext';
import { isNativeApp } from '../utils/platform.js';
import { useWhatsAppHelp } from '../context/WhatsAppHelpContext';
import { useHelpGuide } from '../context/HelpGuideContext';
import useInstallPrompt from '../hooks/useInstallPrompt';
import './AppDock.css';

function InstallIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden>
      <path d="M12 3v12M7 10l5 5 5-5" />
      <path d="M5 21h14" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 1 1 5.82 1c0 2-3 2-3 4" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

export default function AppDock() {
  const { t } = useLang();
  const { installVisible, iosHint, dismissInstall, handleInstall } = useInstallPrompt();
  const { openWhatsAppHelp } = useWhatsAppHelp();
  const { openHelpGuide } = useHelpGuide();

  if (isNativeApp()) return null;

  const contactWa = () => openWhatsAppHelp('dock');
  const installLabel = iosHint ? t.installIosShort : t.installDesktopShort;
  const installTabText = iosHint ? t.installIosShort : t.installSideTab;

  const onInstallClick = () => {
    if (iosHint) dismissInstall();
    else handleInstall();
  };

  return (
    <div className="app-dock" data-sub-free aria-label="Quick actions">
      <aside className="quick-tabs" aria-label={t.helpGuideTitle}>
        {installVisible && (
          <button
            type="button"
            className="quick-tabs__tab quick-tabs__tab--install"
            onClick={onInstallClick}
            aria-label={installLabel}
            title={installLabel}
          >
            <span className="quick-tabs__icon">
              <InstallIcon />
            </span>
            <span className="quick-tabs__text">{installTabText}</span>
          </button>
        )}
        <button
          type="button"
          className="quick-tabs__tab quick-tabs__tab--help"
          onClick={openHelpGuide}
          aria-label={t.helpGuideTitle}
          title={t.helpGuideTitle}
        >
          <span className="quick-tabs__icon">
            <HelpIcon />
          </span>
          <span className="quick-tabs__text">{t.navHelp}</span>
        </button>
      </aside>

      <button
        type="button"
        className="app-dock__wa"
        onClick={contactWa}
        aria-label={t.navWhatsApp}
        title={t.navWhatsApp}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.75.75 0 0 0 .914.914l4.458-1.495A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.72 9.72 0 0 1-4.95-1.35l-.355-.21-3.28 1.1 1.1-3.19-.23-.37A9.75 9.75 0 1 1 12 21.75z" />
        </svg>
      </button>
    </div>
  );
}
